import { mapGetters } from "vuex";
import SummerNote from "../../SummerNoteEditor/SummerNote";
import NotificationContactInfo from "../NotificationContactInfo/NotificationContactInfo";
import ReportStatusTasks from "../ReportStatusTasks/ReportStatusTasks";
import * as utiliy from "../../../Utility/commonUtilities";
import { GetUserDetails } from "../../../config/app.config";
import * as salesReportService from "../../../Service/Report.service";
import * as constants from "../../../Constants/ReportTypesConstants";
import * as ReportSchemaModel from "../../../Models/ReportSchema";
import { toasterModel, toasterColor } from "../../../Models/ToasterModel";
import {
  ReportTabsConstants,
  ReportTabsArray,
} from "../../../Constants/ReportTabsConstant";
import { Capitalize } from "../../../Utility/Capitalize";
import * as notificationService from "../../../Service/Notification.service";
import { Roles } from "../../../Constants/RolesConstants";
import { ReportStatuses } from "../../../Constants/ReportTypesConstants";
import firestore from "../../../config/firebase";
import TelerikReport from "../../../views/TelerikReport/TelerikReport.vue";

export default {
  components: {
    SummerNote,
    NotificationContactInfo,
    ReportStatusTasks,
    TelerikReport,
  },

  computed: {
    showSaveButton() {
      switch (this.getUserDetails.role) {
        case Roles.Admin:
          return true;

        case Roles.Manager:
          return true;
        case Roles.Leader:
          if (
            this.currentReport.ReportStatus == ReportStatuses.Working ||
            this.currentReport.ReportStatus == ReportStatuses.Reopened
          ) {
            return true;
          } else {
            return false;
          }
      }
    },
    showAcceptAndClose() {
      switch (this.getUserDetails.role) {
        case Roles.Admin:
          if (this.currentReport.ReportStatus == ReportStatuses.Accepted)
            return false;
          else return true;
        case Roles.Manager:
          if (this.currentReport.ReportStatus == ReportStatuses.Accepted)
            return false;
          else return true;
        case Roles.Leader:
          return false;
      }
    },
    showSubmitButton() {
      switch (this.getUserDetails.role) {
        case Roles.Admin:
          if (
            this.currentReport.ReportStatus == ReportStatuses.Accepted ||
            this.currentReport.ReportStatus == ReportStatuses.Submitted
          )
            return false;
          else return true;
        case Roles.Manager:
          if (
            this.currentReport.ReportStatus == ReportStatuses.Accepted ||
            this.currentReport.ReportStatus == ReportStatuses.Submitted
          )
            return false;
          else return true;
        case Roles.Leader:
          if (
            this.currentReport.ReportStatus == ReportStatuses.Accepted ||
            this.currentReport.ReportStatus == ReportStatuses.Submitted
          )
            return false;
          else return true;
      }
    },
    showReopenedButton() {
      switch (this.getUserDetails.role) {
        case Roles.Admin:
          if (this.currentReport.ReportStatus == ReportStatuses.Accepted)
            return true;
          else return false;
        case Roles.Manager:
          if (this.currentReport.ReportStatus == ReportStatuses.Accepted)
            return true;
          else return false;
        case Roles.Leader:
          return false;
      }
    },
    documentId() {
      if (
        this.getFinancialYear != null &&
        this.getActiveReportMenu.hasOwnProperty("Abbreviation") &&
        this.getSelectedArea.hasOwnProperty("Area") &&
        this.getSelectedTeam.hasOwnProperty("TeamString") &&
        this.getSelectedBranch.hasOwnProperty("OfficeString")
      ) {
        var selectedTeam =
          this.getSelectedTeam.TeamString == "All"
            ? "000"
            : this.getSelectedTeam.TeamString;
        var selectedBranch =
          this.getSelectedBranch.OfficeString == "All"
            ? "0000"
            : this.getSelectedBranch.OfficeString;
        var documentId =
          this.getFinancialYear +
          "-" +
          this.getActiveReportMenu.Abbreviation +
          "-" +
          this.getSelectedArea.Area +
          "-" +
          selectedTeam +
          "-" +
          selectedBranch;

        return documentId;
      }
      return null;
    },
    currentReport() {
      var currentPeriodReport = null;
      if (this.reportStatus.hasOwnProperty("Response")) {
        var filteredReport = this.reportStatus.Reports.filter(
          (x) => x.Period == this.getFilterPeriod
        );
        if (filteredReport.length > 0) {
          currentPeriodReport = filteredReport[0];
        }
      }

      return currentPeriodReport;
    },

    reportStatusIcon() {
      if (this.currentReport != null) {
        switch (this.currentReport.ReportStatus) {
          case constants.ReportStatuses.Working:
            return {
              icon: "description",
              description: "IN PROGRESS",
            };
            break;

          case constants.ReportStatuses.Submitted:
            return {
              icon: "bookmark",
              description: "SUBMITTED",
            };
            break;

          case constants.ReportStatuses.Accepted:
            return {
              icon: "done",
              description: "ACCEPTED",
            };
            break;

          case constants.ReportStatuses.Reopened:
            return {
              icon: "description",
              description: constants.ReportStatuses.Reopened,
            };
            break;
        }
      }
      return {
        icon: "",
        description: "",
      };
    },
    ...mapGetters([
      "getSelectedArea",
      "getSelectedTeam",
      "getSelectedBranch",
      "getUserDetails",
      "getFilterPeriod",
      "getFinancialYear",
      "getActiveReportMenu",
    ]),
  },

  data() {
    return {
      addCommentId: "addComment",
      activeTab: 0,
      userDetails: {},
      reportStatus: {},
      ReportTabs: ReportTabsArray(),
      isNotificationPopup: false,
      htmltoPrint: "",
      reportStatuses: ReportStatuses,
      roles: Roles,
      realtime: "",
      documentIdList: [],
      telerikReportParameters: {},
      expand: false,
    };
  },

  async mounted() {
    await this.$store.dispatch("getAreaBranchTeamService");
    this.$router.app.$on("CloseContentInfoPopup", this.closeContentInfoPopup);
    this.$router.app.$on(
      "onTelerikReportDrillDown",
      this.onTelerikReportDrillDown
    );

    let context = this;

    this.$nextTick(() => {
      context.loadReportData();
    });
  },

  methods: {
    contentForSummerNote(tab) {
      var content = this.currentReport[tab.field];
      try {
        if (this.currentReport.ReportStatus != ReportStatuses.Accepted) {
          var contentDom = $.parseHTML(content);
          var allDivElements = $(contentDom).filter("div");
          if (allDivElements.length > 0) {
            var lastCommentDiv = allDivElements[0];

            if (
              this.getUserDetails.userName ==
              $(lastCommentDiv).attr("data-name")
            ) {
              var editIcon = $(lastCommentDiv).find(".icon")[0];
              editIcon.style.display = "inline";

              var tmp = document.createElement("div");
              contentDom.forEach((item) => {
                tmp.appendChild(item);
              });

              return tmp.innerHTML;
            }
          }
        }
      } catch (e) {
        return content;
      }
      return content;
    },

    async loadReportData() {
      let context = this;

      if (this.documentId == null) {
        return false;
      }

      if (this.documentIdList.filter((x) => x == this.documentId).length == 0) {
        this.realtime = firestore
          .collection(constants.FirebaseCollectionName.Reports)
          .doc(this.documentId)
          .onSnapshot(function(doc) {
            if (context.documentId == doc.id && doc.exists == true) {
              context.reportStatus = doc.data().data;
            }
          });
      }
      this.documentIdList.push(this.documentId);
      var report = await salesReportService.getReportStatusInfoById(
        this.documentId,
        constants.FirebaseCollectionName.Reports
      );

      ///Create a new Report
      if (report.exists == false) {
        var reportStatusSchema = this.createNewReportStatus();
        this.reportStatus = await salesReportService.createorUpdateDocument(
          this.documentId,
          constants.FirebaseCollectionName.Reports,
          reportStatusSchema
        );
      } else {
        //if document already exist,check whether there is a record with the specified date filter
        this.reportStatus = report.data().data;
        if (
          this.reportStatus.Reports.filter(
            (x) => x.Period == this.getFilterPeriod
          ).length == 0
        ) {
          var reportModel = ReportSchemaModel.reportSchema(
            this.getFilterPeriod,
            constants.ReportStatuses.Working
          );
          this.reportStatus.Reports.push(reportModel);

          this.reportStatus = await salesReportService.createorUpdateDocument(
            this.documentId,
            constants.FirebaseCollectionName.Reports,
            this.reportStatus
          );
        }
      }
    },

    createNewReportStatus() {
      var reportStatusSchema = ReportSchemaModel.reportStatusSchema();

      var reportModel = ReportSchemaModel.reportSchema(
        this.getFilterPeriod,
        constants.ReportStatuses.Working
      );
      reportStatusSchema.Reports.push(reportModel);

      return reportStatusSchema;
    },
    // From html extract img tag and update it with new firebase url
    async processSummerNoteContent(summerNoteContent) {
      var html = $.parseHTML(summerNoteContent);

      var imageTags = $(html).find("img");
      let i = 0;
      for (i = 0; i < imageTags.length; i++) {
        var image = imageTags[i];
        let fetchBlobFromDataUrl = await fetch(image.src);

        if (fetchBlobFromDataUrl.ok) {
          var blob = await fetchBlobFromDataUrl.blob();

          var upload = await salesReportService.UploadImage(blob, Date.now());
          if (upload.state == "success") {
            var imageUrl = await upload.ref.getDownloadURL();
            image.src = imageUrl;
          }
        }
      }
      var div = $("<div</div>");
      div.append(html);

      return div[0].innerHTML;
    },

    async saveContent(reportStatus) {
      this.$store.commit("toggleLoading", true);

      var existingData = this.reportStatus.Reports.filter(
        (x) => x.Period == this.getFilterPeriod
      )[0].Report;
      // Fetching data from enable summernote response
      var addCommentSummerNote = document.getElementById(this.addCommentId);

      var addCommentSummerNoteContent = $(addCommentSummerNote).summernote(
        "code"
      );

      var commentHtml = $.parseHTML(addCommentSummerNoteContent);
      var isEditedComment = commentHtml[0].id == "Copied";

      if (isEditedComment) {
        // Removing span
        commentHtml.splice(0, 1);
        var tmp = document.createElement("div");
        commentHtml.forEach((item) => {
          tmp.appendChild(item);
        });
        addCommentSummerNoteContent = tmp.innerHTML;

        // Removing exiting comment from orginal data
        var existingHtml = $.parseHTML(existingData);
        if (existingHtml[0].dataset.name == this.getUserDetails.userName) {
          existingHtml.splice(0, 1);

          var tmp1 = document.createElement("div");
          existingHtml.forEach((item) => {
            tmp1.appendChild(item);
          });
          existingData = tmp1.innerHTML;
        }
        debugger;
      }

      addCommentSummerNoteContent = await this.processSummerNoteContent(
        addCommentSummerNoteContent
      );

      if (addCommentSummerNoteContent.trim().length == 0) {
        this.$store.commit(
          "toaster",
          toasterModel("Comment is empty", toasterColor.info)
        );

        this.$store.commit("toggleLoading", false);
        return false;
      }

      var messageToAppend = utiliy.generateSummerNoteMessage(
        addCommentSummerNoteContent,
        this.getUserDetails.userName
      );

      var activeTab = this.ReportTabs[this.activeTab];

      this.reportStatus.Reports.filter(
        (x) => x.Period == this.getFilterPeriod
      )[0].Report = messageToAppend + existingData;

      this.activeTab = 0;

      this.$store.commit("toaster", toasterModel("Successfully Added Comment"));
      this.clearSummerNote();
      this.reportStatus = await salesReportService.createorUpdateDocument(
        this.documentId,
        constants.FirebaseCollectionName.Reports,
        this.reportStatus
      );
      debugger;
      if (this.reportStatus.hasOwnProperty("Response")) {
        this.sendNotification();
      }
      this.$store.commit("toggleLoading", false);
    },

    async changeReportStatus(reportStatus) {
      var currrentReport = this.reportStatus.Reports.filter(
        (x) => x.Period == this.getFilterPeriod
      )[0];
      currrentReport.ReportStatus = reportStatus;

      this.reportStatus = await salesReportService.createorUpdateDocument(
        this.documentId,
        constants.FirebaseCollectionName.Reports,
        this.reportStatus
      );

      this.$store.commit(
        "toaster",
        toasterModel("Successfully " + reportStatus)
      );
      // switch (reportStatus) {

      //   case ReportStatuses.Accepted:

      //     break;
      //   case ReportStatuses.Reopened:

      //     break;
      //   case ReportStatuses.Submitted:
      //       currrentReport.ReportStatus = reportStatus;
      //     break;
      // }
    },

    closeContentInfoPopup() {
      this.isNotificationPopup = false;
    },

    async sendNotification() {
      var contactsToNotify = await notificationService.getContactsToNotify(
        this.getSelectedArea.Area,
        this.getSelectedTeam.Team,
        this.getSelectedBranch.Office,
        this.getActiveReportMenu.Name
      );

      var notificationMessage = utiliy.generateNotificationMessage(
        this.getUserDetails.userName,
        this.getActiveReportMenu.Name
      );
      if (contactsToNotify.length > 0) {
        contactsToNotify.forEach((contact) => {
          notificationService.sendNotification(
            notificationMessage,
            contact.Number
          );
        });
      }
    },

    printReports() {
      let reportSubmittedBy = "";
      let reportSubmittedOn = "";

      let context = this;
      context.htmltoPrint = "";
      context.htmltoPrint =
        "<div><img src='logo-lbc.png'></div><br/><br/><div style='margin-bottom: 27px;'><h3>" +
        context.getActiveReportMenu.Name +
        " Report<span style='float:right;font-size: medium;text-align: right;'><div><v-btn flat > Area: " +
        context.getSelectedArea.Area +
        "</v-btn><v-btn flat> Team: " +
        context.getSelectedTeam.Team +
        "</v-btn> <v-btn flat> Office: " +
        context.getSelectedBranch.Office +
        "</v-btn></div><div><v-btn flat>" +
        reportSubmittedBy +
        "</v-btn></div><div><v-btn flat>" +
        reportSubmittedOn +
        "</v-btn></div></span></h3></div><hr/><br/><v-layout><v-flex><div align='center'></div>";
      $("#summerNotesReadOnly .summernote").each(function(index, item) {
        if (index == 3) {
          return false;
        }
        if ($(this).summernote("code")) {
          context.htmltoPrint +=
            "<div style='margin-bottom: 25px;'><h2 style='font-size: medium;margin-bottom:10px;'>" +
            $(this).attr("id") +
            ":</h2><div>" +
            $(this).summernote("code") +
            "</div></div>";
        }
      });

      context.htmltoPrint += "</v-flex></v-layout></v-card>";

      setTimeout(function() {
        context.$htmlToPaper("printReport");
      }, 1000);
    },

    clearSummerNote() {
      var addCommentSummerNote = document.getElementById(this.addCommentId);
      $(addCommentSummerNote).summernote("code", "");
    },
    onTelerikReportDrillDown(telerikReport) {
      this.telerikReportParameters = telerikReport;

      var tabObj = {
        name: telerikReport.name,
        field: telerikReport.name,
        type: "tlreport",
      };
      var index = this.ReportTabs.findIndex((x) => x.type == "tlreport");
      if (index >= 0) {
        this.ReportTabs.splice(index, 1);
      }

      this.$nextTick(() => {
        this.ReportTabs.push(tabObj);
        this.activeTab = index >= 0 ? index : this.ReportTabs.length - 1;
      });
    },
    expandSummernote() {
      this.expand = !this.expand;
      if (this.expand && this.activeTab > 0) {
        this.onTelerikReportDrillDown(this.telerikReportParameters);
      }
    },
  },

  watch: {
    // On date filter check whether a document exist for the following filter
    documentId(newDocumentId, oldPeriod) {
      this.loadReportData();
    },
    getFilterPeriod() {
      this.loadReportData();
    },
    "getActiveReportMenu.Abbreviation"() {
      var index = this.ReportTabs.findIndex((x) => x.type == "tlreport");
      if (index >= 0) {
        this.ReportTabs.splice(index, 1);
      }
      this.loadReportData();
    },
  },

  beforeDestroy() {
    this.$router.app.$off("CloseContentInfoPopup");
    this.$router.app.$off(
      "onTelerikReportDrillDown",
      this.onTelerikReportDrillDown
    );
  },
};

$(document).on("click", ".icon", function(event) {
  try {
    var content = $(event.currentTarget)
      .parent()
      .find('div[name="content"]');

    var addCommentSummerNote = document.getElementById("addComment");
    $(addCommentSummerNote).summernote(
      "code",
      `<span id="Copied" style="display:none;">Copied</span> ${
        content[0].innerHTML
      }`
    );
  } catch (e) {}
});
